var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("产品信息")))])]), _c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataForm,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.DATARULE
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品代码"),
      prop: "code"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品代码")
    },
    model: {
      value: _vm.dataForm.code,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "code", $$v);
      },
      expression: "dataForm.code"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品名称")
    },
    model: {
      value: _vm.dataForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "name", $$v);
      },
      expression: "dataForm.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备案号"),
      prop: "recordNumber"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("备案号")
    },
    model: {
      value: _vm.dataForm.recordNumber,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "recordNumber", $$v);
      },
      expression: "dataForm.recordNumber"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备案名称"),
      prop: "recordName"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("备案名称")
    },
    model: {
      value: _vm.dataForm.recordName,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "recordName", $$v);
      },
      expression: "dataForm.recordName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保单位"),
      prop: "unitId"
    }
  }, [this.id == -1 ? _c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("承保单位"),
      "show-search": "",
      allowClear: "",
      "option-filter-prop": "children",
      "filter-option": _vm.dropDownSearchNo,
      disabled: this.id != -1 ? true : false
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.dataForm.unitId,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "unitId", $$v);
      },
      expression: "dataForm.unitId"
    }
  }, _vm._l(_vm.unitList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1) : _c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.dataForm.unitName,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "unitName", $$v);
      },
      expression: "dataForm.unitName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保机构"),
      prop: "agencyId"
    }
  }, [this.id == -1 ? _c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("承保机构"),
      "show-search": "",
      allowClear: "",
      "option-filter-prop": "children",
      "filter-option": _vm.dropDownSearchNo,
      disabled: _vm.dataForm.unitId && this.id == -1 ? false : true
    },
    on: {
      change: _vm.onAgencyChange
    },
    model: {
      value: _vm.dataForm.agencyId,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "agencyId", $$v);
      },
      expression: "dataForm.agencyId"
    }
  }, _vm._l(_vm.agencyList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1) : _c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.dataForm.agencyName,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "agencyName", $$v);
      },
      expression: "dataForm.agencyName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("中介机构")
    }
  }, [this.id == -1 ? _c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("中介机构"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.dropDownSearchNo,
      disabled: this.id != -1 ? true : false
    },
    model: {
      value: _vm.dataForm.intermediaryId,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "intermediaryId", $$v);
      },
      expression: "dataForm.intermediaryId"
    }
  }, _vm._l(_vm.intermediaryList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1) : _c("a-input", {
    attrs: {
      placeholder: "-",
      disabled: true
    },
    model: {
      value: _vm.dataForm.intermediaryName,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "intermediaryName", $$v);
      },
      expression: "dataForm.intermediaryName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品说明"),
      prop: "description"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("产品说明")
    },
    model: {
      value: _vm.dataForm.description,
      callback: function ($$v) {
        _vm.$set(_vm.dataForm, "description", $$v);
      },
      expression: "dataForm.description"
    }
  })], 1)], 1)], 1)], 1), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("条款文件")))])]), _c("div", {
    staticStyle: {
      "padding-left": "40px"
    }
  }, [_c("a-checkbox", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      checked: _vm.checked
    },
    on: {
      change: _vm.changeChecked
    }
  }, [_vm._v(_vm._s(_vm.$t("当前产品无条款文件")))])], 1), !_vm.checked ? _c("a-form-model", {
    ref: "termsRef",
    attrs: {
      model: _vm.termsForm,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 15
      },
      rules: _vm.TERMRULE
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    model: {
      value: _vm.termsForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.termsForm, "name", $$v);
      },
      expression: "termsForm.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("条款文件"),
      prop: "linkName"
    }
  }, [_c("a-upload", {
    attrs: {
      action: _vm.uploadFile,
      multiple: false,
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      },
      data: {
        module: "insuranceTerms"
      },
      accept: ".pdf",
      "before-upload": _vm.beforeUpload,
      fileList: _vm.fileList,
      showUploadList: {
        showRemoveIcon: false
      },
      disabled: _vm.uploadStatus
    },
    on: {
      change: _vm.handleChange
    }
  }, [_c("a-button", [_c("a-icon", {
    attrs: {
      type: "upload"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("选择文件")) + " ")], 1)], 1), _c("span", {
    staticStyle: {
      color: "#f5222d"
    }
  }, [_vm._v("*" + _vm._s(_vm.$t("仅支持上传PDF格式文件，最大不超5M")))])], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文本内容"),
      prop: "content"
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor",
    staticStyle: {
      height: "400px"
    },
    attrs: {
      options: _vm.quillOption
    },
    model: {
      value: _vm.termsForm.content,
      callback: function ($$v) {
        _vm.$set(_vm.termsForm, "content", $$v);
      },
      expression: "termsForm.content"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 2
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.saveTermsLoading
    },
    on: {
      click: _vm.addTermsFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加")) + " ")])], 1)], 1) : _vm._e(), _vm.tableData.length != 0 && !_vm.checked ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("文件确认")))])]) : _vm._e(), _vm.tableData.length != 0 && !_vm.checked ? _c("a-table", {
    attrs: {
      size: "small",
      pagination: false,
      rowKey: "id",
      bordered: "",
      columns: _vm.COLUMNSLIST,
      "data-source": _vm.tableData
    },
    scopedSlots: _vm._u([{
      key: "linkName",
      fn: function (text, record) {
        return [_c("a-button", {
          attrs: {
            type: "link"
          },
          on: {
            click: function ($event) {
              return _vm.onPreview(record);
            }
          }
        }, [_vm._v(_vm._s(text || record.file))])];
      }
    }, {
      key: "operation",
      fn: function (_, record, index) {
        return [_c("a-button", {
          staticStyle: {
            "margin-right": "20px"
          },
          attrs: {
            size: "small",
            type: "edit"
          },
          on: {
            click: function ($event) {
              return _vm.handleEdit(record, index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]), _c("a-button", {
          attrs: {
            size: "small",
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.handleDelete(record, index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }], null, false, 2885430459)
  }, _vm._l(_vm.COLUMNSLIST, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0) : _vm._e(), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      disabled: _vm.disabled,
      loading: _vm.saveLoading
    },
    on: {
      click: _vm.nextFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1), _vm.termsShow ? _c("terms-model", {
    ref: "termsRef2",
    on: {
      ok: _vm.updateTermsFun,
      cancel: function ($event) {
        _vm.termsShow = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };